import { useState, useCallback } from 'react';

// Fonctionnalités débloquées à certains niveaux
const UNLOCKS = {
  5:  'Mode Duel débloqué !',
  10: 'Mode Multijoueur débloqué !',
  15: 'Tournois débloqués !',
  20: 'Questions Légendaires débloquées !',
  30: 'Titre "Expert" débloqué !',
  50: 'Titre "Légende" débloqué !',
};

// Pièces gagnées au level-up = niveau * 100
const coinsForLevel = (level) => level * 100;

/**
 * Hook useLevelUp
 * Retourne: { checkLevelUp, levelUpData, clearLevelUp }
 *
 * checkLevelUp(oldLevel, newUser) → compare le niveau AVANT la partie au niveau
 * renvoyé par le serveur (déjà calculé et plafonné à 100 côté DB) et affiche le
 * popup si ça a progressé. Ne recalcule jamais l'XP/niveau côté client : le
 * serveur est la seule source de vérité (évite de compter l'XP en double et
 * les niveaux fantômes au-delà du plafond).
 */
function useLevelUp() {
  const [levelUpData, setLevelUpData] = useState(null); // { newLevel, coinsEarned, unlockedFeature }

  const checkLevelUp = useCallback((oldLevel, newUser) => {
    if (!newUser) return newUser;

    const newLevel = newUser.level || newUser.niveau || oldLevel;

    if (newLevel > oldLevel) {
      const coins = coinsForLevel(newLevel);
      const unlockedFeature = UNLOCKS[newLevel] || null;
      setLevelUpData({ newLevel, coinsEarned: coins, unlockedFeature });
    }

    return newUser;
  }, []);

  const clearLevelUp = useCallback(() => setLevelUpData(null), []);

  return { checkLevelUp, levelUpData, clearLevelUp };
}

export default useLevelUp;
